(() => {
  function arrangePremiumProductInfo(root = document) {
    const wrapper = root.querySelector('.m-main-product .m-product-info--wrapper');
    if (!wrapper || wrapper.dataset.raPremiumArranged === 'true') return;

    const title = wrapper.querySelector('.main-product__block-title');
    const price = wrapper.querySelector('.main-product__block-price');
    const review = wrapper.querySelector('.main-product__block-image');
    const firstBlock = wrapper.firstElementChild;

    if (title && firstBlock && title !== firstBlock) {
      wrapper.insertBefore(title, firstBlock);
    }

    if (price && title && price.previousElementSibling !== title) {
      title.insertAdjacentElement('afterend', price);
    }

    if (review && price && review.previousElementSibling !== price) {
      price.insertAdjacentElement('afterend', review);
    }

    wrapper.dataset.raPremiumArranged = 'true';
  }

  document.addEventListener('DOMContentLoaded', () => arrangePremiumProductInfo());
  document.addEventListener('shopify:section:load', (event) => arrangePremiumProductInfo(event.target));
})();
